import React from "react";
import styled from "styled-components";
import { ApolloError } from "@apollo/client/errors";
import { useRouteMatch } from "react-router-dom";
import { VistActivityItem as VistActivityItemEntity } from "../../generated/graphql";
import { Section } from "../../components/Page/Section";
import { StyledLink, LargeText } from "../../components/shared/typography";
import Button from "../../components/shared/Button";
import LoadingIndicator from "../../components/shared/LoadingIndicator";
import { VistActivityItem } from "../../components/VistActivity/VistActivityItem";

interface ActivitiesSectionProps {
  loading: boolean;
  onRetry: () => void;
  error: ApolloError | undefined;
  shownActivities: VistActivityItemEntity[] | undefined;
}

const ActivityWrapper = styled.div`
  display: flex;
  flex-direction: column;

  span > p {
    margin: 2px 0 0 0;
    text-align: right;
    padding: 0;
    opacity: 0.75;
    font-family: Muli;
    font-size: 12px;
    font-weight: 600;
    line-height: 2;
    letter-spacing: 0.17px;
    color: ${(props) => props.theme.colors.grey};
  }
`;

const GreyLargeText = styled(LargeText)`
  color: #909090;
`;

const ActivitiesSection = ({
  loading,
  onRetry,
  error,
  shownActivities,
}: ActivitiesSectionProps) => {
  const match = useRouteMatch();

  return (
    <Section maxColumns={1}>
      {error && (
        <div role="alert">
          <GreyLargeText>
            {shownActivities?.length
              ? "Activities could not be refreshed. Showing the last loaded activities."
              : "Activities could not be loaded."}
          </GreyLargeText>
          <Button secondary disabled={loading} onClick={onRetry}>
            Retry
          </Button>
        </div>
      )}
      {loading && shownActivities === undefined ? (
        <LoadingIndicator />
      ) : shownActivities?.length ? (
        shownActivities.map((activity: VistActivityItemEntity) => (
          <ActivityWrapper key={activity.id}>
            <StyledLink to={`${match.path}/vist-activity/${activity.id}`}>
              <VistActivityItem activity={activity} />
            </StyledLink>
          </ActivityWrapper>
        ))
      ) : !error ? (
        <GreyLargeText style={{ marginTop: "32px", marginBottom: "8px" }}>
          No logs found, try clearing the filters. New activities appear after
          upload completes.
        </GreyLargeText>
      ) : null}
    </Section>
  );
};

export default ActivitiesSection;
